import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { useCart } from "../../features/cart/context/CartContext";
import { AuthContext } from "../../features/auth/context/AuthContext";
import { useWishlist } from "../../features/wishlist/context/WishlistContext";

// Account covers every account page, so it stays highlighted on orders and addresses too.
const ACCOUNT_PATHS = ["/account", "/my-orders", "/address-book", "/orderdetails"];

const NavItem = ({ to, icon, label, active, count }) => (
  <Link
    to={to}
    className={`bottom-nav__item${active ? " is-active" : ""}`}
    aria-current={active ? "page" : undefined}
  >
    <span className="bottom-nav__icon">
      <i className={`${active ? "ph-fill" : "ph"} ${icon}`} aria-hidden="true" />
      {count > 0 && <span className="bottom-nav__badge">{count}</span>}
    </span>
    <span className="bottom-nav__label">{label}</span>
  </Link>
);

const MobileBottomNav = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { pathname } = useLocation();
  const { cartCount } = useCart();
  const { wishlistCount } = useWishlist();

  return (
    <nav className="bottom-nav d-md-none" aria-label="Main">
      <NavItem to="/" icon="ph-house" label="Home" active={pathname === "/"} />
      {/* Show wishlist only if user is authenticated */}
      {isAuthenticated && (
        <NavItem
          to="/wishlist"
          icon="ph-heart"
          label="Wishlist"
          active={pathname === "/wishlist"}
          count={wishlistCount}
        />
      )}
      <NavItem to="/cart" icon="ph-shopping-cart-simple" label="Cart" active={pathname === "/cart"} count={cartCount} />
      <NavItem
        to="/account"
        icon="ph-user"
        label="Account"
        active={ACCOUNT_PATHS.some((path) => pathname.startsWith(path))}
      />
    </nav>
  );
};

export default MobileBottomNav;
